/**
 * Background: Channel Steering have two Email containers
 * Util Email functions set
 */

import classNames from 'classnames';

const validEmailType = ['textarea', 'text', 'date', 'number', 'select'];

// Validate Email webform; check input options
function isValidatedSubmitForm(fields) {
  if (Array.isArray(fields) && fields.length > 0) {
    const validateFields = fields.some(field => (
      validEmailType.includes(field.type)
    ));
    return validateFields;
  }
  return false;
}

// Hide the submit button, if there is no input area
function hideSubmitButton(fields) {
  return classNames({
    'hide-submit-btn': !isValidatedSubmitForm(fields),
  });
}

// Logout Email form access query
const logoutEmailQuery = 'email';

module.exports = {
  hideSubmitButton,
  logoutEmailQuery,
};
